import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../components/Header';
import { BreadcrumbBox } from '../../components/common/Breadcrumb';
import CourseSidebar from './components/CourseSidebar';
import CourseItemGrid from './components/CourseItemsGrid';
import FooterTwo from '../../components/FooterTwo';
import { Styles } from './styles/course.js';
import ExamItemGrid from './components/ExamItemsGrid.js';

class ExamGrid extends Component {

    render() {
        return (
            <div className="main-wrapper course-page">

                {/* Header 2 */}
                <Header />

                {/* Breadcroumb */}
                <BreadcrumbBox title="Competitive Exams" />

                <Styles>
                    {/* Course Grid */}
                    <section className="course-grid-area">
                        <Container>
                            <Row>
                                {/* <Col lg="3" md="4" sm="5">
                                    <CourseSidebar />
                                </Col> */}
                                <Col lg="9" md="8" sm="7">
                                    <div className="course-items">
                                        <Row>
                                            <ExamItemGrid />
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </section>
                </Styles>

                {/* Footer 2 */}
                <FooterTwo />

            </div>
        )
    }
}

export default ExamGrid